/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-05-15 11:14:50
 * @LastEditors: Ali2vu
 * @LastEditTime: 2020-06-15 16:17:16
 */

export default {
    path: 'audit',
    component: () => import( /* webpackChunkName: "autidt-list" */ '@/pages/common/Empty'),
    children: [
      {
        path: 'bill',
        component: () => import(/* webpackChunkName: "autidt-bill" */ '@/pages/audit/Bill'),
        meta: {title:'业务清单审核'},
      },
      {
        path: 'delay_bill',
        component: () => import(/* webpackChunkName: "autidt-bill" */ '@/pages/audit/DelayBill'),
        meta: {title:'业务清单延迟'},
      },
      {
        path: 'contract',
        component: () => import(/* webpackChunkName: "autidt-contract" */ '@/pages/audit/Contract'),
        meta: {title:'合同审核'},
      },
      {
        path: 'task',
        component: () => import(/* webpackChunkName: "autidt-task" */ '@/pages/audit/Task'),
        meta: {title:'结算审核'},
      },
      {
        path: 'GTask',
        component: () => import(/* webpackChunkName: "autidt-task" */ '@/pages/audit/GreenCityTask'),
        meta: {title:'绿城佣金审核'},
      },
      {
        path: 'view',
        component: () => import(/* webpackChunkName: "autidt-view" */ '@/pages/audit/BatchDetail'),
        meta: {title:'审核明细'},
      },
      {
        path: 'SignedBankCard',
        component: () => import(/* webpackChunkName: "autidt-view" */ '@/pages/audit/SignedBankCard'),
        meta: {title:'签约银行卡必填管理'},
      },
      {
        path: 'pinganWhite',
        component: () => import('@/pages/audit/pinganWhiteList'),
        meta: {title:'平安入金白名单'},
      }
    ]
  }
